if (!customElements.get("video-controls")) {
    customElements.define(
      "video-controls",
      class VideoControls extends HTMLElement {
        constructor() {
          super();
        }
        

        connectedCallback() {
          this.video = this.querySelector("video");
          this.hasVideoClickToggle = this.dataset.videoClick === "false" ? false : true;
          this.productsContainer = this.querySelector(
            ".shoppable-video__products",
          );
          this.controlButton = this.querySelector(
            ".shoppable-video__control-button",
          );
          
          this.togglePlayPause = this.togglePlayPause.bind(this);
          this.toggleVideoIcon = this.toggleVideoIcon.bind(this);

          this.addEventListeners();
          if(this.controlButton && this.video) this.toggleVideoIcon();
        }
        
        addEventListeners() {
          if(this.controlButton) this.controlButton.addEventListener("click", this.togglePlayPause);
          if(this.video && this.hasVideoClickToggle) this.video.addEventListener("click", this.togglePlayPause);
          if(this.controlButton && this.video){
            this.video.addEventListener("play", this.toggleVideoIcon);
            this.video.addEventListener("pause", this.toggleVideoIcon);
          }
        }
        
        removeEventListeners() {
          if(this.controlButton) this.controlButton.removeEventListener("click", this.togglePlayPause);
          if(this.video && this.hasVideoClickToggle) this.video.removeEventListener("click", this.togglePlayPause);
          if(this.controlButton && this.video){
            this.video.removeEventListener("play", this.toggleVideoIcon);
            this.video.removeEventListener("pause", this.toggleVideoIcon);
          }
        }

        toggleVideoIcon() {
          const isPlaying = !this.video.paused;
          this.controlButton.classList.toggle(
            "shoppable-video__control-button--play",
            isPlaying,
          );
          this.controlButton.classList.toggle(
            "shoppable-video__control-button--pause",
            !isPlaying,
          );
        }

        togglePlayPause(e) {
          e.preventDefault();
          const videoElement = this.video;      
          
          if (!videoElement) return;

          if (videoElement.paused || videoElement.ended) {
            videoElement.play();
          } else {
            videoElement.pause();
          }
        }

        disconnectedCallback(){
          this.removeEventListeners();
        }

      },
    );
  }
  


document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.videos-lookbook').forEach(section => {
    const videos = section.querySelectorAll('video');

    // --- IntersectionObserver to pause videos outside viewport ---
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const video = entry.target;
        if (!entry.isIntersecting && !video.paused) {
          video.pause();
        }
      });
    }, {
      threshold: 0.25 // 25% visible to count as "in viewport"
    });

    // --- Setup video behaviors ---
    videos.forEach(video => {
      // Observe each video
      observer.observe(video);

      // Track if paused manually
      video.addEventListener('pause', () => {
        if (!video.ended) {
          video.dataset.pausedByUser = "true";
        }
      });

      // Play on hover (only if not paused manually)
      video.addEventListener('mouseenter', () => {
        if (video.dataset.pausedByUser === "true") return;

        // Pause all other videos first
        videos.forEach(other => {
          if (other !== video && !other.paused) {
            other.pause();
          }
        });

        video.play();
      });

      // Ensure only one video plays at a time if user clicks play
      video.addEventListener('play', () => {
        videos.forEach(other => {
          if (other !== video && !other.paused) {
            other.pause();
          }

          // Reset pausedByUser flag for others
          if (other !== video) {
            delete other.dataset.pausedByUser;
          }
        });
      });
    });
  });
});



